export default {
	postulants_index: ({ postulants_index }) => {
		return postulants_index;
	},
};
